"use client";

import { Typography } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { memo } from "react";
import { IndustryHeroProps } from "./types";
import { ROUTES } from "@/constants";

const IndustryHero = ({ content, className }: IndustryHeroProps) => {
  const { heroTitle, heroDescription, heroImage } = content;

  const imageUrl = heroImage?.fields?.file?.url
    ? `https:${heroImage.fields.file.url}`
    : null;

  const imageDimensions = heroImage?.fields?.file?.details?.image;
  return (
    <section
      className={cn(
        "overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero",
        className
      )}
      itemScope
      itemType="https://schema.org/Service"
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 pb-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[minmax(0,259fr)_minmax(0,301fr)] lg:gap-0 lg:py-20">
          <div className="flex flex-col lg:justify-center gap-8 lg:max-w-[518]">
            <div className="grid grid-cols-1 place-content-start gap-4 md:gap-8">
              <Typography variant="headingMain" className="w-full">
                <h1 itemProp="name">{heroTitle}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p itemProp="description">{heroDescription}</p>
              </Typography>
            </div>
            <meta itemProp="serviceType" content="Translation Services" />
            <meta itemProp="provider" content="Languex" />
            <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap lg:gap-2.5">
              <Button
                asChild
                variant="primary"
                className="sm:w-[247px] h-[48px]"
              >
                <Link href={ROUTES.getQuote} className="!text-base w-full">
                  Get  a quote
                </Link>
              </Button>
            </div>
          </div>
          {imageUrl && (
            <div className="flex items-start">
              <Image
                alt="Languex Illustration"
                src={imageUrl}
                width={imageDimensions?.width || 602}
                height={imageDimensions?.height || 516}
                className="flex-auto min-w-0"
                quality={100}
                itemProp="image"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(IndustryHero);
